import { isAuthenticatedAndHasAdminRights, isSuperAdmin } from '@/utils/nav-guards-checks';

const routes = [
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/app/admin/pages/admin-portal-page'),
    beforeEnter: isAuthenticatedAndHasAdminRights,
    redirect: { name: 'clients' },
    children: [
      {
        path: 'clients',
        name: 'clients',
        component: () => import('@/app/admin/pages/admin-clients'),
      },
      {
        path: 'agents',
        name: 'agents',
        component: () => import('@/app/admin/pages/admin-agents'),
        beforeEnter: isSuperAdmin,
      },
      {
        path: '/agents/:id',
        name: 'agent',
        component: () => import('@/app/admin/pages/admin-agent-details'),
        beforeEnter: isSuperAdmin,
      },
      {
        path: '/clients/:id',
        name: 'client',
        component: () => import('@/app/admin/pages/admin-client-details'),
      },
      {
        path: 'buy-package',
        name: 'buy-package',
        component: () => import('@/app/main/pages/main-payment'),
      },
    ],
  },
];

export default routes;
